import { Api } from 'utils';

class QuoteService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/quotes/get',params),
		getClients: async (params?: any) => Api.createResponse('admin/quotes/clients',params),
		accept: async (params?: any) => Api.createResponse('admin/quotes/accept',params),
		reject: async (params?: any) => Api.createResponse('admin/quotes/reject',params),
		getHolidays: async (params?: any) => Api.createResponse('admin/quotes/get-holidays',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/quotes/change-status',params),
		cancelQuote: async (params?: any) => Api.createResponse('admin/quotes/cancel-quote',params),
		getJourneys: async (params?: any) => Api.createResponse('admin/quotes/get-journeys',params),
		getQuotesMonth: async (params?: any) => Api.createResponse('admin/quotes/get-quotes-month',params),
		editDate: async (params?: any) => Api.createResponse('admin/quotes/edit-date',params),
		getOperators: async (params?: any) => Api.createResponse('admin/quotes/operators',params),
		saveOperators: async (params?: any) => Api.createResponse('admin/quotes/save-operators',params),
		download: async (params?: any) => Api.createResponse('admin/quotes/download',params),
		changePrice: async (params?: any) => Api.createResponse('admin/quotes/change-price',params),
		changePayment: async (params?: any) => Api.createResponse('admin/quotes/change-payment',params),
		generateLink: async (params?: any) => Api.createResponse('admin/quotes/generate-link',params),
		resendMail: async (params?: any) => Api.createResponse('admin/quotes/resend-mail',params),
		getQuotePayment: async (params?: any) => Api.createResponse('admin/quotes/quote-payment',params),
		getSurvey: async (params?: any) => Api.createResponse('admin/quotes/survey',params),
		viewImages: async (params?: any) => Api.createResponse('admin/quotes/images',params),
	}

}

export default QuoteService;